import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Zoom from "@mui/material/Zoom";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { TEXT } from "./constants";

interface IdleStateProps {
  isUploading: boolean;
}

export const IdleState: React.FC<IdleStateProps> = ({ isUploading }) => {
  return (
    <Box textAlign="center" padding={1} width="100%">
      <Zoom in={true} timeout={500}>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          <UploadFileIcon fontSize="large" color="secondary" />
          <Typography
            variant="body2"
            color="textSecondary"
            dangerouslySetInnerHTML={{ __html: TEXT.UPLOAD_INSTRUCTIONS }}
          />
          <Box marginTop={2}>
            <Button
              variant="outlined"
              disabled={isUploading}
              sx={{
                transition: (theme) =>
                  theme.transitions.create(
                    ["background-color", "transform", "color"],
                    {
                      duration: theme.transitions.duration.standard,
                    }
                  ),
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              {isUploading ? TEXT.UPLOADING_TEXT : TEXT.UPLOAD_BUTTON_TEXT}
            </Button>
          </Box>
        </Stack>
      </Zoom>
    </Box>
  );
};
